import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReset = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M21.0707 1.75308L21.0604 9.25307L13.5604 9.24283L13.5638 6.74283L16.898 6.74738C15.8005 5.60985 14.3053 5.01285 12.8104 4.87265C9.09882 4.52452 5.80773 7.25118 5.4596 10.9628C5.4272 11.3083 5.42143 11.6499 5.44056 11.9858L5.45562 12.25H2.94896L2.93845 12.011C2.91989 11.5892 2.93001 11.1613 2.97053 10.7293C3.44759 5.64304 7.9576 1.90651 13.0439 2.38357C14.9609 2.56338 17.0051 3.33128 18.5664 4.87648L18.5707 1.74966L21.0707 1.75308ZM2.9292 22.2469L2.93944 14.7469L10.4394 14.7572L10.436 17.2572L7.1019 17.2526C8.19938 18.3902 9.69457 18.9872 11.1894 19.1274C14.9011 19.4755 18.1921 16.7488 18.5403 13.0372C18.5727 12.6917 18.5784 12.3501 18.5593 12.0142L18.5443 11.75H21.0509L21.0614 11.989C21.08 12.4108 21.0699 12.8387 21.0293 13.2707C20.5523 18.357 16.0423 22.0935 10.956 21.6164C9.03893 21.4366 6.99476 20.6687 5.43347 19.1235L5.4292 22.2503L2.9292 22.2469Z",
		fill: "currentColor"
	})]
});
export default SvgReset;
